import React, { useState, useEffect, useContext } from "react";
// *** Services
import { SengridActions } from "services";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Group from "@material-ui/icons/Group";
import Email from "@material-ui/icons/Email";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import style from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import { UsuarioContext } from "config/context/UsuarioProvider";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
ValidatorForm.addValidationRule("isTruthy", (value) => value);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(style);
var pinRef = React.createRef();

export default function ConfirmarCorreo({ validateForm, setbtnDisable }) {
  const { usuario, setusuario, signupModalPin, setSignupModalPin } = useContext(
    UsuarioContext
  );
  const [bloquearBoton, setBloquearBoton] = useState(false);
  const [colorBoton, setcolorBoton] = useState("primary");
  

  const classes = useStyles();
  useEffect(() => {
    //cargar validar correo
    SengridActions.enviarPin(usuario.token, usuario.email).then(
      (responsePin) => {
        setusuario({ ...usuario, pin: "" });
        setSignupModalPin({ mensaje: "", open: true, modificarData: false });
      }
    );
  }, []);
  return (
    <div>
      <Dialog
        disableBackdropClick
        classes={{
          root: classes.modalRoot,
          paper: classes.modal + " " + classes.modalSignup,
        }}
        open={signupModalPin.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() =>
          setSignupModalPin({
            ...signupModalPin,
            open: false,
            modificarData: true,
          })
        }
        aria-labelledby="signup-modal-slide-title"
        aria-describedby="signup-modal-slide-description"
      >
        <Card plain className={classes.modalSignupCard}>
          <DialogTitle
            id="signup-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h3 className={classes.cardTitle + " " + classes.modalTitle}>
              Validación de Datos
            </h3>
          </DialogTitle>
          <DialogContent
            id="signup-modal-slide-description"
            className={classes.modalBody}
          >
            <GridContainer>
              <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
                <InfoArea
                  className={classes.infoArea}
                  title="¿En qué consiste?"
                  description={
                    <p>
                      Le enviamos un código al correo electrónico{" "}
                      {usuario.email}. Busque el código que se encuentra en su
                      correo electrónico e ingréselo en la casilla que se
                      encuentra al lado, si escribió mal el correo electrónico o
                      desea modificar los datos ingresados en el formulario
                      anterior haga clic en el botón "Modificar mis datos".
                    </p>
                  }
                  icon={Group}
                  iconColor="info"
                />
                <div className={classes.textCenter}>
                  <Button
                    round
                    color="primary"
                    onClick={(event) => {
                      setSignupModalPin({ open: false, modificarData: true });
                      setbtnDisable(false)
                    }}
                  >
                    Modificar Mis Datos
                  </Button>
                </div>
              </GridItem>
              <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
                <form className={classes.form}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    inputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}
                        >
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      placeholder: usuario.email,
                      readOnly: true,
                    }}
                  />
                  {signupModalPin.modificarData === false ? (
                    <div>
                      <TextValidator
                        fullWidth
                        autoFocus
                        ref={pinRef}
                        onBlur={(e) => pinRef.current.validate(e.target.value)}
                        id="txtPin"
                        label="Ingrese Código"
                        type="number"
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 8);
                        }}
                        value={usuario.pin}
                        onChange={(e) =>
                          setusuario({ ...usuario, pin: e.target.value })
                        }
                        validators={["isTruthy", "required"]}
                        errorMessages={["Campo requerido"]}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              className={classes.inputAdornment}
                            >
                              <Icon className={classes.inputAdornmentIcon}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <div className={classes.textCenter}>
                        <Button
                          round
                          color={colorBoton}
                          disabled={bloquearBoton}
                          onClick={(event) => {
                            validateForm();
                            setBloquearBoton(true);
                            setcolorBoton("");
                            const timer = setTimeout(() => {
                              setBloquearBoton(false);
                              setcolorBoton("primary");
                            }, 10000);
                            return () => clearTimeout(timer);
                          }}
                        >
                          Validar Código
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </form>
              </GridItem>
            </GridContainer>
            <h6
              className={classes.cardTitle + " " + classes.modalTitle}
              style={{ color: "red" }}
            >
              {signupModalPin.mensaje}
            </h6>
          </DialogContent>
        </Card>
      </Dialog>
    </div>
  );
}
